'use client';

import * as React from 'react';

/**
 * Set by `Popover.Trigger`: true when the panel opens attached, so an open
 * PopoverButton squares its bottom corners onto the panel.
 */
const PopoverButtonAttachedContext = React.createContext(false);

export const PopoverButtonAttachedProvider =
  PopoverButtonAttachedContext.Provider;

export function usePopoverButtonAttached(): boolean {
  return React.useContext(PopoverButtonAttachedContext);
}
